"use strict";

exports.__esModule = true;
exports.default = exports.largerDevicesWidth = exports.baseWidth = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var baseWidth = function baseWidth(props) {
  if (props.fullWidth || props.responsive) return '100%';
  return props.width || 'auto';
};

exports.baseWidth = baseWidth;

var largerDevicesWidth = function largerDevicesWidth(props) {
  // larger devices ignore the responsive prop
  if (props.fullWidth) return '100%';
  return props.width || 'auto';
}; // renders either a masked input or a raw input. Style this as needed


exports.largerDevicesWidth = largerDevicesWidth;

var InputFactory = function InputFactory(_ref) {
  var size = _ref.size,
      error = _ref.error,
      fullWidth = _ref.fullWidth,
      responsive = _ref.responsive,
      mask = _ref.mask,
      filteredProps = _objectWithoutPropertiesLoose(_ref, ["size", "error", "fullWidth", "responsive", "mask"]);

  return mask ? _react.default.createElement(_reactTextMask.default, _extends({
    guide: false,
    mask: mask
  }, filteredProps, {
    render: function render(ref, rp) {
      return _react.default.createElement("input", _extends({
        ref: ref
      }, rp));
    }
  })) : _react.default.createElement("input", filteredProps);
};

InputFactory.propTypes = {
  mask: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.func]),
  size: (0, _propTypes.oneOf)(['small', 'regular']),
  error: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string]),
  fullWidth: _propTypes.bool,
  responsive: _propTypes.bool
};
InputFactory.defaultProps = {
  mask: undefined,
  size: undefined,
  error: undefined,
  fullWidth: undefined,
  responsive: undefined
};
var _default = InputFactory;
exports.default = _default;